export default __webpack_public_path__ + "static/media/news.084d3b5a.svg";